import React, { useEffect, useRef, useState } from 'react';
import '../../styles/Membership.css';

export default function MembershipFaq() {

    const [selectedFAQ, setSelectedFAQ] = useState(0);
    const faqRefsMembership = useRef({});

    useEffect(() => {
        Object.keys(faqRefsMembership.current).forEach(id => {
            const el = faqRefsMembership.current[id];
            if (el) {
                el.style.maxHeight = selectedFAQ == id ? `${el.scrollHeight}px` : '0px';
            }
        });
    }, [selectedFAQ]);

    function renderFAQS() {
        const cantoFAQ = [
        {
            id: 1,
            question: "Who qualifies for CANTO membership?",
            answer: "CANTO has two main membership types: Active (Full) Members: Telecommunications companies or administrations that operate public networks in the Caribbean. Affiliate Members: Service providers, equipment suppliers, consultants, government departments, regulatory bodies, and others with a vested interest in Caribbean telecommunications."
        },
        {
            id: 2,
            question: "What benefits do CANTO members receive?",
            answer: "Members receive exclusive discounts on conference registration, networking opportunities with industry leaders, access to CANTO’s Working Committees, and exclusive resources like the CANTO Annual Directory, which includes contacts for key decision-makers in the ICT sector."
        },
        {
            id: 3,
            question: "How do members participate in CANTO’s events?",
            answer: "Members have access to annual events such as the CANTO Annual Conference & Trade Exhibition and the Annual General Meeting, with opportunities to attend workshops, networking sessions, and specialized industry discussions. Member discounts on event registration apply."
        },
        {
            id: 4,
            question: "How often is the Annual General Meeting held?",
            answer: "The Annual General Meeting (AGM) is held once a year in February. During the AGM, CANTO members review the Annual Report and elect new Directors if necessary."
        },
        {
            id: 5,
            question: "Can members showcase their products and services at CANTO events?",
            answer: "Yes, members can book exhibition booths and secure speaking slots at the Annual Conference & Trade Exhibition, providing them with the chance to launch new products and services or meet key stakeholders in the ICT industry."
        },
        {
            id: 6,
            question: "Are presentations from CANTO events accessible to members?",
            answer: "Yes, presentations from CANTO events, including the Annual Conference, are posted on the CANTO website for members to access after the event."
        },
        {
            id: 7,
            question: "What is the CANTO Annual Directory, and who has access to it?",
            answer: "The CANTO Annual Directory is an exclusive resource available to members, containing valuable contact information for top decision-makers in the ICT industry, including operators, regulators, and vendors."
        },
        {
            id: 8,
            question: "Are CANTO’s publications available to members?",
            answer: "Members have exclusive access to the CANTO Annual Directory. While the Cancion magazine is publicly available, the directory provides in-depth industry contacts crucial for networking."
        },
        {
            id: 9,
            question: "How can I become a member of CANTO?",
            answer: "Please contact our Business Development Manager, Nicole Freakley at nfreakley@canto.org to become a CANTO member."
        },
        {
            id: 10,
            question: "What does CANTO Membership cost?",
            answer: "Please contact our Business Development Manager, Nicole Freakley at nfreakley@canto.org to find out more."
        }
        ];

        const render_faqs = cantoFAQ.map((faq, index) => 
            <div className='faq-item' style={{background: '#282C68', borderRadius: '8px', padding: '15px 20px'}} onClick={() => {
                setSelectedFAQ(prevId => prevId == faq.id ? null : faq.id);
            }}>
            <div className='faq-item-title' style={{color: '#fff'}}>
                {faq.question}
                <div className='faq-item-icon-container'>
                    <div className='faq-bar' style={{background: '#fff'}}></div>
                    <div className='faq-bar rotate' style={{background: '#fff', rotate: (selectedFAQ == faq.id) ? '0deg' : '90deg'}}></div>
                </div>
            </div>
            <div className='faq-item-text' 
            ref={el => faqRefsMembership.current[faq.id] = el}
            style={{
                maxHeight: '0px',
                overflow: 'hidden',
                transition: 'max-height 0.3s ease-in-out',
                color: '#efefef'
            }}>
                {faq.answer}
            </div>
                
            </div>
        )

        return render_faqs;
    } 


  return (
    <div className='container' style={{marginTop: '100px'}}>
        <div className='membership-types-container'>
            <div className='members-table-header'>
            <div style={{flex: 1, marginLeft: '-100px'}}>CANTO Membership FAQ's</div>
            </div>
            {renderFAQS()}
            
        </div>
    </div>
  )
}
